import { Attachment, DomainResource, Extension } from 'fhir/r4';

export function getSignatureAttachment(resource: DomainResource | undefined | null, extensionUrl: string): Attachment | undefined {
  if (!resource?.extension?.length) {
    return undefined;
  }
  const extension = resource.extension.find(ext => ext.url === extensionUrl);
  return extension?.valueAttachment;
}

export function setSignatureAttachment(resource: DomainResource, extensionUrl: string, attachment: Attachment | null): void {
  const existing = Array.isArray(resource.extension) ? resource.extension : [];
  const filtered = existing.filter(ext => ext.url !== extensionUrl);

  if (attachment) {
    filtered.push({
      url: extensionUrl,
      valueAttachment: attachment
    } as Extension);
  }

  resource.extension = filtered.length ? filtered : undefined;
}

export function attachmentToDataUrl(attachment: Attachment | undefined): string | null {
  if (!attachment) {
    return null;
  }
  if (attachment.url) {
    return attachment.url;
  }
  if (!attachment.data) {
    return null;
  }
  const contentType = attachment.contentType || 'image/png';
  return `data:${contentType};base64,${attachment.data}`;
}

export function hasSignatureAttachment(resource: DomainResource | undefined | null, extensionUrl: string): boolean {
  return !!getSignatureAttachment(resource, extensionUrl);
}

export function getBooleanExtensionValue(resource: DomainResource | undefined | null, extensionUrl: string): boolean | null {
  if (!resource?.extension?.length) {
    return null;
  }
  const extension = resource.extension.find(ext => ext.url === extensionUrl);
  return extension?.valueBoolean ?? null;
}

export function setBooleanExtensionValue(resource: DomainResource, extensionUrl: string, value: boolean | null): void {
  const existing = Array.isArray(resource.extension) ? resource.extension : [];
  const filtered = existing.filter(ext => ext.url !== extensionUrl);

  if (value !== null) {
    filtered.push({
      url: extensionUrl,
      valueBoolean: value
    } as Extension);
  }

  resource.extension = filtered.length ? filtered : undefined;
}
